import { MuiAlert, MuiButton, MuiTypography, typography, createTheme, palette } from '@dentalux/ui-library-core'
import { generateColorPalette } from '@dentalux/ui-library-core/constants/colors/paletteGenerator'
import { Theme } from '@mui/material/styles'
import { shadows } from 'src/config/styles'

const createBrandedTheme = (brandColor: string | null | undefined): Theme => {
  const themePalette = { ...palette }
  if (brandColor) {
    // Generate custom color palette
    const { primary, secondary, background } = generateColorPalette(brandColor)
    themePalette.primary = primary
    themePalette.secondary = secondary
    themePalette.background = background
  }
  return createTheme({
    variant: 'external',
    shadows,
    typography,
    components: {
      MuiTypography,
      MuiButton,
      MuiAlert,
    },
    palette: themePalette,
  })
}

export default createBrandedTheme
